<template>
  <div>
    <data-table :service="ProductService"
                service-method="filterProducts"
                :service-params="serviceParams"
                operations="add"
                :entity="entity"
                :columns="columns"
                :filters="filters"
                :disable-permission-checks="true"
                :go-to-details-on-row-click="false"
                :go-to-add-on-click="false"
                @on-add="addNewPricing"
                ref="table">

      <template v-slot:product_job_board.name="{row}">
        {{row.product_job_board.name}}
      </template>
      <template v-slot:job_board="{row}">
        {{(getJobBoardById(row.product_job_board.job_board_id) || {}).name}}
      </template>
      <template v-slot:product_job_board.price="{row}">
        {{row.product_job_board.price | toCurrency}}
      </template>

      <template v-slot:price="{row}">
        <b>{{row.price | toCurrency}}</b> &nbsp; ({{priceDifferencePercentage(row)}}%)
      </template>

      <template v-slot:extra-buttons="{row, index}">
        <base-button outline
                     @click.stop="onDelete(row, index)" type="danger" icon size="sm">
          <i class="far fa-trash-alt"></i>
        </base-button>
      </template>
    </data-table>

    <modal :show.sync="showAddModal" v-if="showAddModal">
      <h6 slot="header">{{$t('product.list.addClientProduct', { clientName: client.name })}}</h6>
      <form @submit.prevent="saveClientPricing">
        <div class="row">
          <div class="col-12">
            <fg-input :label="$t('generic.product')"
                      :error="getError($t('generic.product'))"
                      required>
              <product-select :options="jobPostingProducts"
                              :name="$t('generic.product')"
                              v-model="selectedProduct"
                              @change="onProductChange"
                              v-validate="'required|not_empty_object'">
              </product-select>
            </fg-input>
          </div>
          <div class="col-12">
            <fg-input :label="$t('generic.jobBoard')"
                      :error="getError($t('generic.jobBoard'))"
                      required>
              <JobBoardsForProductAutocomplete :disabled="!productSelected"
                                               :product-id="selectedProduct.product_id"
                                               :name="$t('generic.jobBoard')"
                                               option-key="id"
                                               v-validate="'required'"
                                               v-model="addModel.product_job_board_id">
              </JobBoardsForProductAutocomplete>
            </fg-input>
          </div>
          <div class="col-12">
            <fg-input :label="$t('product.list.add.newPrice')"
                      v-model="addModel.price"
                      v-validate="'required|min_value:0'"
                      :error="getError($t('product.list.add.newPrice'))"
                      :name="$t('product.list.add.newPrice')"
                      type="number"
                      step="0.01"
                      required>
            </fg-input>
          </div>
          <div class="col-6">
            <submit-button native-type="submit"/>
          </div>
        </div>

      </form>
    </modal>
  </div>
</template>
<script>
  import ProductService from 'src/services/ProductService'
  import ProductSelect from 'src/components/Autocomplete/ProductSelect'
  import JobBoardsForProductAutocomplete from 'src/components/Autocomplete/JobBoardsForProductAutocomplete'
  import entities from 'src/config/entities'
  import { mapGetters, mapState } from 'vuex'
  export default {
    name: 'client-management-products',
    components: {
      ProductSelect,
      JobBoardsForProductAutocomplete
    },
    data() {
      return {
        ProductService,
        entity: entities.PRODUCT,
        showAddModal: false,
        addModel: {
          client_id: this.$route.params.id,
          user_id: null,
          product_id: null,
          product_job_board_id: null,
          price: null,
          expire_date: null
        },
        selectedProduct: {},
        selectedBoard: {}
      }
    },
    computed: {
      ...mapGetters('config', ['jobPostingProducts', 'getJobBoardById']),
      ...mapState('client', {
        client: state => state.currentClient
      }),
      productSelected() {
        return Object.keys(this.selectedProduct).length > 0
      },
      columns () {
        return [
          {
            prop: 'product_job_board.name',
            label: this.$t('product.list.labels.name'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'job_board',
            label: this.$t('product.list.labels.jobBoard'),
            minWidth: '150px'
          },
          {
            prop: 'product_job_board.price',
            label: this.$t('product.list.labels.priceNormal'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'price',
            label: this.$t('product.list.labels.priceClient'),
            minWidth: '150px',
            sortable: true
          }
        ]
      },
      filters() {
        return []
      },
      serviceParams() {
        return {
          client_id: this.$route.params.id
        }
      }
    },
    methods: {
      priceDifferencePercentage(row) {
        let diff = row.product_job_board.price - row.price
        return Math.round(diff/row.product_job_board.price * 100)
      },
      addNewPricing() {
        this.showAddModal = true
      },
      onProductChange(product) {
        this.addModel.price = product.price
        this.addModel.product_job_board_id = null
      },
      async onDelete(row, index) {
        await this.$refs.table.beforeDelete(row)
        await ProductService.deleteProductPricing(row.id)
        this.$refs.table.tableData.splice(index, 1)
      },
      async saveClientPricing() {
        let valid = await this.$validator.validateAll()
        if (!valid) {
          return
        }
        this.addModel.product_id = this.selectedProduct.product_id
        await ProductService.createProductPricing(this.addModel)
        this.showAddModal = false
        await this.$refs.table.getTableData()
      }
    }
  }
</script>
<style>
</style>
